import React from 'react';

interface InfoCardProps {
    title: string;
    children: React.ReactNode;
    className?: string;
}

export const InfoCard: React.FC<InfoCardProps> = ({
    title,
    children,
    className = ''
}) => {
    return (
        <div className={`flex-1 rounded-radius-lg border border-hex-gray-200 bg-hex-gray-50 p-4 ${className}`}>
            <div className="text-spacing-md font-semibold text-hex-gray-700 mb-2">{title}</div>
            {children}
        </div>
    );
};

export default InfoCard;
